export default {
  authority_age_gteq_three_months:
    'Minimum operating authority age of three months',
  authority_age_gteq_six_months:
    'Minimum operating authority age of six months',
  bipd_insurance_limit_gteq_750_000:
    'Minimum auto liability coverage of $750,000',
  bipd_insurance_limit_gteq_1_000_000:
    'Minimum auto liability coverage of $1,000,000',
  cargo_insurance_limit_gteq_100_000:
    'Minimum cargo insurance coverage of $100,000',
  safety_rating_satisfactory_or_unrated:
    'Safety Rating is one of Satisfactory or Unrated',
  has_been_inspected_in_the_last_twenty_four_months:
    'Carrier has been inspected at least once in the last 24 months',
  safer_operating_status_active: 'Operating Status is Active or Authorized',
  no_active_oos_orders: 'Carrier has no active Out-Of-Service Orders',
  interstate_carrier_authority_is_active:
    'Interstate carrier authority is active',
  has_verified_physical_location_activity:
    'Carrier has verified physical location or asset activity',
  has_verified_manually_entered_identifier:
    'Carrier has verified manually entered identifier',
};
